<script>
  // core components
  import UserDropdown from "components/Dropdowns/UserDropdown.svelte";
  import { t } from 'svelte-i18n';
  import NotificationDropdown from "components/Dropdowns/NotificationDropdown.svelte";
  import { isMobileStore } from '../../stores/media';
  import ChatRoom from "components/Chat/ChatRoom.svelte";

</script>

<!-- Navbar -->
<nav
  class="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4"
>
  <div
    class="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4"
  >
    <!-- Brand -->
    <a
      class="text-white text-sm uppercase hidden lg:inline-block font-semibold"
      href="#erpsys" on:click={(e) => e.preventDefault()}
    >
      {$t('app.name')} &copy;
    </a>
    
    {#if !$isMobileStore}
      <!-- User -->
      <ul class="flex-col md:flex-row list-none items-center hidden md:flex">
        <li class="inline-block relative">
          <ChatRoom />
        </li>
        <li class="inline-block relative">
          <NotificationDropdown />
        </li>
        <li class="inline-block relative">
          <UserDropdown />
        </li>
      </ul>
    {/if}

  </div>
</nav>
<!-- End Navbar -->
